import React from 'react';
import type ReactType from 'react';
import * as S from './styled';
import cls from 'classnames';

export interface Props {
  className?: string;
  stickyFooter?: boolean;
}

const ModalContent: ReactType.FC<Props> = (props) => {
  return (
    <S.ModalContent
      $stickyFooter={props.stickyFooter}
      className={cls('ModalContent', props.className)}
    >
      {props.children}
    </S.ModalContent>
  );
};

export default ModalContent;
